import { ANALYTE_TYPE } from './analytes/helpers';
import { ANALYTE_RESULT_TYPE, DOCTOR_TYPE, FORECAST_TYPE, HEALTH_INSIGHTS_CATEGORY_TYPE, HEALTH_INSIGHTS_TAG_TYPE, HEALTH_INSIGHTS_TYPE, INTERVENTION_ANALYTE_TYPE, REPORT_ANALYTE_COMMENT_TYPE, ROLE_TYPE, TEST_FAILURE_CLASSIFICATION_TYPE, TEST_PANEL_TYPE, TEST_PROFILE_TYPE, TEST_REPORT_TYPE, TEST_REQUEST_TYPE, TEST_RESULT_ATTACHMENT_TYPE, TEST_RESULT_TYPE } from './helpers';
import { INTERVENTION_SET_TYPE } from './intervention-sets/helpers';
import { INTERVENTION_TYPE } from './interventions/helpers';
import { TEST_CYCLES_TYPE } from './test-cycles/helpers';
/**
 * Check if an object is a Doctor object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isDoctor = (item) => item.type === DOCTOR_TYPE;
/**
 * Check if an object is a TestProfile object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isTestProfile = (item) => item.type === TEST_PROFILE_TYPE;
/**
 * Check if an object is a TestResult object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isTestResult = (item) => item.type === TEST_RESULT_TYPE;
/**
 * Check if an object is a TestReport object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isTestReport = (item) => item.type === TEST_REPORT_TYPE;
/**
 * Check if an object is a TestPanel object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isTestPanel = (item) => item.type === TEST_PANEL_TYPE;
/**
 * Check if an object is a TestFailureClassification object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isTestFailureClassification = (item) => item.type === TEST_FAILURE_CLASSIFICATION_TYPE;
/**
 * Check if an object is an Intervention object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isIntervention = (item) => item.type === INTERVENTION_TYPE;
/**
 * Check if an object is an InterventionSet object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isInterventionSet = (item) => item.type === INTERVENTION_SET_TYPE;
/**
 * Check if an object is a TestResultAttachment object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isTestResultAttachment = (item) => item.type === TEST_RESULT_ATTACHMENT_TYPE;
/**
 * Check if an object is an InterventionAnalyte object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isInterventionAnalyte = (item) => item.type === INTERVENTION_ANALYTE_TYPE;
/**
 * Check if an object is a Test object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isTestCycle = (item) => item.type === TEST_CYCLES_TYPE;
/**
 * Check if an object is a AnalyteResult object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isAnalyteResult = (item) => item.type === ANALYTE_RESULT_TYPE;
/**
 * Check if an object is a Analyte object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isAnalyte = (item) => item.type === ANALYTE_TYPE;
/**
 * Check if an object is a Health Insight object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isHealthInsights = (item) => item.type === HEALTH_INSIGHTS_TYPE;
/**
 * Check if an object is a Health Insight Category object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isHealthInsightCategory = (item) => item.type === HEALTH_INSIGHTS_CATEGORY_TYPE;
/**
 * Check if an object is a Health Insight Tag object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isHealthInsightTag = (item) => item.type === HEALTH_INSIGHTS_TAG_TYPE;
/**
 * Check if an object is a TestRequest object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isTestRequest = (item) => item.type === TEST_REQUEST_TYPE;
/**
 * Check if an object is a ReportAnalyteComment object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isReportAnalyteComment = (item) => item.type === REPORT_ANALYTE_COMMENT_TYPE;
/**
 * Check if an object is a Forecast object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isForecast = (item) => item.type === FORECAST_TYPE;
/**
 * Check if an object is a Role object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isRole = (item) => item.type === ROLE_TYPE;
//# sourceMappingURL=type-guards.js.map